// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3JtYR","error":"Textarea_error__3h2hJ","readonly":"Textarea_readonly__QkSxp","disabled":"Textarea_disabled__3fL2i"};